import axios from "axios";
import ServerGridConfig from "../../../../config/ServerGridConfig";
import { convertFranchiseeViewAddress, convertParentFranchiseeViewAddress, convertTextToID } from "../../../../utils/GlobalFunction";
import { action, decorate, observable } from "mobx";

export default class ManageFranchiseeInqApplicationStore {
	agGrid = null;
	per_page = ServerGridConfig.options.paginationPageSize;
	current_page = 1;
	list_data = null;
	viewValues = null;
	updateAppValues = null;
	deleteValues = null;
	dropdown_franchisee_application_list = null;
	//viewApplicationLog
	viewAppLogList = null
	agGridViewAppLogList = null
	kycDetailsValues = null

	// set form values to view
	setViewValues = (data) => {
		if (data) {
			data.address = convertFranchiseeViewAddress(data);
			data.p_address = convertParentFranchiseeViewAddress(data)
		}
		this.viewValues = data;
	};

	// set form values to view kycDetails
	setKycDetailsValues = (data) => {
		this.kycDetailsValues = data
	}

	// set form values to Edit
	setUpdateAppValues = (data) => {
		this.updateAppValues = data
	}

	// set form values to delete
	setDeleteValues = (data) => {
		this.deleteValues = data
	}

	// set form values to viewAppLog
	setViewAppLogList = (data) => {
		this.viewAppLogList = data
	}

	// Setup grid and set column size to autosize
	setupGrid = (params) => {
		this.agGrid = params;
		const { api } = params;
		let datasource = this.createDatasource(ServerGridConfig.options);
		api.setServerSideDatasource(datasource);
	};

	setupGridViewAppLogList = (params) => {
		this.agGridViewAppLogList = params;
	};

	// change page size, default page size is LocalGridConfig.options.paginationPageSize
	setPageSize = (page = this.per_page) => {
		this.per_page = page;
		if (this.agGrid) {
			this.agGrid.api.paginationSetPageSize(parseInt(page));
		}
	};

	// call api to get records
	getList = (payload) => {
		return axios.post(`/organization/franchisee-inquiry-app/list`, payload).then(({ data }) => {
			if (data.list.data.length) {
				let startPage = (data.list.current_page - 1) * data.list.per_page;
				data.list.data.map((item, index) => {
					item.srno = startPage + index + 1;
					return null;
				});
			}
			this.list_data = data.list ? data.list.data : null;
			this.total = data.list.total;
			this.current_page = data.list.current_page;
			return data;
		});
	};

	// Filter function for no record found message
	changeFilterAndSort = (params) => {
		var final_filter = params.filterModel;
		var final_sort = params.sortModel;
		if (final_filter["status.id"]) {
			final_filter['status.id'].values = convertTextToID(final_filter['status.id'], this.dropdown_franchisee_application_list, 'name', 'id')
		}

		return { final_filter, final_sort };
	};

	// Filter function for no record found message
	onFilterChanged = (params) => {
		this.agGrid = params;
		if (this.agGrid && this.agGrid.api.getModel().getRowCount() === 0) {
			this.agGrid.api.showNoRowsOverlay();
		}
		if (this.agGrid && this.agGrid.api.getModel().getRowCount() > 0) {
			this.agGrid.api.hideOverlay();
		}
	};

	// Filter function for no record found message
	onFilterChangedViewAppLogList = (params) => {
		this.agGridViewAppLogList = params;
		if (this.agGridViewAppLogList && this.agGridViewAppLogList.api.getModel().getRowCount() === 0) {
			this.agGridViewAppLogList.api.showNoRowsOverlay();
		}
		if (this.agGridViewAppLogList && this.agGridViewAppLogList.api.getModel().getRowCount() > 0) {
			this.agGridViewAppLogList.api.hideOverlay();
		}
	};

	// Create data source to display record in table
	createDatasource = (gridOptions) => {
		return {
			gridOptions,
			getRows: (params) => {
				var filter_data = this.changeFilterAndSort(params.request);
				var payload = {
					filter_data: filter_data.final_filter,
					sort_data: filter_data.final_sort,
					per_page: params.request.endRow - params.request.startRow,
					page: Math.ceil(
						(params.request.startRow + 1) /
						(params.request.endRow - params.request.startRow)
					),
				};
				this.getList(payload).then((data) => {
					if (data.list.total === 0) {
						this.agGrid.api.showNoRowsOverlay();
					} else {
						this.agGrid.api.hideOverlay();
					}
					params.successCallback(data.list.data, data.list.total);
					var allColumnIds = [];
					if (this.agGrid && this.agGrid.columnApi && data.total) {
						this.agGrid.columnApi.getAllColumns().forEach(function (column) {
							allColumnIds.push(column.col_id);
						});
					}
				});
			},
		};
	};

	// call api to get records
	ViewData = (ID) => {
		return axios.get(`/organization/franchisee-inquiry-app/view/${ID}`).then(({ data }) => {
			this.setViewValues(data.view);
			this.setKycDetailsValues(data.kyc_details)
			return data;
		});
	};

	// Call edit api
	UpdateAppData = (ID, formdata) => {
		return axios.post(`/organization/franchisee-inquiry-app/edit/${ID}`, formdata)
			.then(({ data }) => {
				if (this.agGrid) {
					this.setupGrid(this.agGrid);
				}
				return data;
			})
			.catch(({ response: { data } }) => {
				var errors = [];
				var notify = null;
				if (data && data?.STATUS) {
					const { NOTIFICATION, ...fieldErrors } = data.STATUS;
					if (NOTIFICATION) {
						notify = NOTIFICATION[0];
					}
					Object.keys(fieldErrors).forEach((name) => {
						errors.push({ name, errors: data.STATUS[name] });
					});
				}
				return Promise.reject({ errors, notify });
			});
	};

	// Call delete api
	DeleteData = (formdata) => {
		return axios.delete(`/organization/franchisee-inquiry-app/delete/` + formdata.id)
			.then(({ data }) => {
				if (this.agGrid) {
					this.setupGrid(this.agGrid);
				}
				return data;
			})
			.catch((response) => {
				return Promise.reject(response);
			});
	};

	getFranchiseeApplicationList = (conditional = {}) => {
		return axios.post(`/organization/franchisee-inquiry-app/lov`, conditional)
			.then(({ data }) => {
				this.dropdown_franchisee_application_list = data.lov;
				return data;
			})
			.catch((response) => {
				return Promise.reject(response);
			});
	};

	ViewAppLogListData = (USERID) => {
		return axios.get(`/organization/franchisee-inquiry-app/logs/${USERID}`).then(({ data }) => {
			this.setViewAppLogList(data.logs);
			return data;
		});
	};
}

decorate(ManageFranchiseeInqApplicationStore, {
	per_page: observable,
	agGrid: observable,
	list_data: observable,
	allColumnIds: observable,
	setupGrid: action,
	setPageSize: action,
	getList: action,
	onFilterChanged: action,
	setViewValues: action,
	viewValues: observable,
	updateAppValues: observable,
	setUpdateAppValues: action,
	dropdown_franchisee_application_list: observable,
	getFranchiseeApplicationList: action,
	deleteValues: observable,
	setDeleteValues: action,
	viewAppLogList: observable,
	setViewAppLogList: action,
	agGridViewAppLogList: observable,
	setupGridViewAppLogList: action,
	onFilterChangedViewAppLogList: action,
	kycDetailsValues: observable,
	setKycDetailsValues: action
});
